import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DataTableComponent } from './data-table/data-table.component';
import { StpMaterialModule } from '../material/material.module';
import { StpApiClientModule } from '../../stp-app/api-client/api-client.module';
import { DataTableConventionService } from './services/data-table-convention.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StpMaterialModule,
    StpApiClientModule
  ],
  exports: [
    DataTableComponent
  ],
  providers: [
    DataTableConventionService
  ],
  declarations: [
    DataTableComponent
  ]
})
export class StpDataTableModule { }
